/**
 * Löst einen Datei-Download im Browser aus (Blob + temporärer Anker, danach wieder freigegeben). Kein
 * Inline-Script oder -Style → bleibt unter der harten CSP zulässig.
 */
export function downloadTextFile(filename: string, text: string, type = 'application/octet-stream'): void {
  const blob = new Blob([text], { type })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
